const traducciones = {
  'Contáctanos': 'Contact Us',
  'Nosotros': 'About us',
  'Beneficios': 'Benefits',
  'Servicios': 'Services',
  'Core Bancario': 'Banking Core',
  'Casos de uso': 'Use Cases',
};

export default traducciones;